
import Honour from '@/components/Honour.vue'
import News from '@/components/News.vue'
import Ourselves from '@/components/Ourselves.vue'
import Product from '@/components/Product.vue'
import NewsDetail from '@/components/NewsDetail.vue'; // 确保路径正确
import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/honour',
    name: 'Honour',
    component:Honour
  },
  {
    path: '/news',
    name: 'News',
    component:News
  },
  {
    path: '/ourselves',
    name: 'Ourselves',
    component:Ourselves
  },
  {
    path: '/product',
    name: 'Product',
    component:Product
  },
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/news/:id',
    name: 'NewsDetail',
    component: NewsDetail
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
